var nb = require('../../../nb');
var storyItem = nb.define({
    view: {
        'class': 'swiper-slide',
        tag:'a',
        target:'_blank',
        href:nb.bind('linkUrl'),
        $html: [{
            'class':'bg-img',
            $html:{
                tag:'img',
                src:nb.bind('imgUrl'),
                alt:nb.bind('title')
            }
        }, {
            'class': 'info',
            $html: [{
                'class': 'info-title ellipsis',
                $text: nb.bind('title')
            }, {
                'class': "info-desc ellipsis",
                $text: nb.bind('subTitle')
            }]
        }]
    }
});
var storyList = nb.define({
    parent: nb.view.List,
    view: {
        'class': 'swiper-wrapper'
    }
});

var story = nb.define({
    view: [{
        'class': 'swiper-container',
        'id': nb.bind('swiperId'),
        $html: {
            $type: storyList,
            $model: 'storyList'
        }
    }, {
        'class': 'swiper-button-prev swiper-button-black'
    }, {
        'class': 'swiper-button-next swiper-button-black'
    }]
});
var storyLstWrapper = nb.define({
    view: {
        'class':'story-list-box',
        $html:{
            'class': 'story-list-wrapper',
            $html: [{
                'class': 'top-icon',
                $html: {
                    tag: 'img',
                    src: './image/icon/icon.svg'
                }
            }, {
                'class': 'story-title',
                $text: '美克家居旗下品牌 A.R.T.西区'
            }, {
                'class': 'swipe-wrapper',
                $html: [{
                    'class': "wrapper-title",
                    $text: '西区故事'
                }, {
                    'class': 'story-list',
                    $html: {
                        $type: story,
                        $model: ''
                    }
                }, {
                    'class': "show-more",
                    $html: {
                        tag: 'a',
                        href:'storyList.html',
                        target:'_blank',
                        $text: '查看更多'
                    }
                }]
            }]
        }
    }
});
module.exports = {
    storyLstWrapper: storyLstWrapper,
    storyItem: storyItem
};


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/StoryListWrapper.js
// module id = 192
// module chunks = 1